// extracted by mini-css-extract-plugin
module.exports = {"content":"publications-module--content--3Q5mO","table":"publications-module--table--1wvcS"};